import React, { useState } from 'react';
import { PageHeader } from '../components/Common.jsx';
import AppearanceSettings from './AppearanceSettings.jsx';
import SecuritySettings from './SecuritySettings.jsx';
import { DynamicIcon } from '../components/icons.jsx';

const SettingsPage = ({ token }) => {
    const [activeTab, setActiveTab] = useState('appearance');

    const tabs = [
        { id: 'appearance', label: 'Appearance', icon: 'Palette' },
        { id: 'security', label: 'Security', icon: 'ShieldLock' },
    ];

    return (
        <div className="space-y-6">
            <PageHeader title="Settings" description="Manage your personal preferences and account security." />

            {/* Tab Navigation */}
            <div className="flex border-b border-gray-200 dark:border-gray-700">
                {tabs.map(tab => (
                    <button
                        key={tab.id}
                        onClick={() => setActiveTab(tab.id)}
                        className={`flex items-center gap-2 px-6 py-3 text-sm font-medium border-b-2 transition-colors ${activeTab === tab.id
                                ? 'border-primary text-primary'
                                : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
                            }`}
                    >
                        <DynamicIcon name={tab.icon} className="w-4 h-4" />
                        {tab.label}
                    </button>
                ))}
            </div>

            {/* Tab Content */}
            <div className="mt-6">
                {activeTab === 'appearance' && <AppearanceSettings token={token} />}
                {activeTab === 'security' && <SecuritySettings token={token} />}
            </div>
        </div>
    );
};

export default SettingsPage;